// extracted by mini-css-extract-plugin
export default {"container":"templates-mfa-module__container","continue-button":"templates-mfa-module__continue-button","feedback":"templates-mfa-module__feedback"};